export default "__VITE_ASSET__DIRwANk5__"